module.exports = __webpack_public_path__ + "img/nys-picture.25f5106b.svg";